import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchNotifications, markAsRead, markAllAsRead } from '../store/slices/notificationsSlice';
import { Loading, EmptyState } from '../components/common';
import { formatRelativeTime } from '../utils/formatters';
import { NOTIFICATION_TYPES } from '../utils/constants';
import { BellIcon, CheckIcon, ClipboardDocumentListIcon, ExclamationCircleIcon, ChatBubbleLeftIcon } from '@heroicons/react/24/outline';

const Notifications = () => {
  const dispatch = useDispatch();
  const { items, loading, unreadCount } = useSelector((state) => state.notifications);

  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  const handleMarkRead = (id) => {
    dispatch(markAsRead(id));
  };

  const handleMarkAllRead = () => {
    dispatch(markAllAsRead());
  };

  const getIcon = (type) => {
    if (type.includes('task')) return ClipboardDocumentListIcon;
    if (type.includes('message')) return ChatBubbleLeftIcon;
    if (type.includes('deadline') || type.includes('overdue')) return ExclamationCircleIcon;
    return BellIcon;
  };

  const getIconColor = (type) => {
    if (type.includes('approved')) return 'bg-green-100 text-green-600';
    if (type.includes('rejected') || type.includes('overdue')) return 'bg-red-100 text-red-600';
    if (type.includes('deadline')) return 'bg-yellow-100 text-yellow-600';
    return 'bg-blue-100 text-blue-600';
  };

  if (loading) return <Loading />;

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Xabarnomalar</h1>
          <p className="text-gray-500">{unreadCount > 0 ? `${unreadCount} ta o'qilmagan xabar` : 'Barcha xabarlar o\'qilgan'}</p>
        </div>
        {unreadCount > 0 && (
          <button onClick={handleMarkAllRead} className="btn-outline">
            <CheckIcon className="w-5 h-5" /> Barchasini o'qilgan deb belgilash
          </button>
        )}
      </div>

      {items.length > 0 ? (
        <div className="space-y-3">
          {items.map((notification) => {
            const Icon = getIcon(notification.notification_type);
            return (
              <div
                key={notification.id}
                onClick={() => !notification.is_read && handleMarkRead(notification.id)}
                className={`card cursor-pointer hover:shadow-md transition-shadow ${!notification.is_read ? 'border-l-4 border-l-blue-500 bg-blue-50/50' : ''}`}
              >
                <div className="flex items-start gap-4">
                  <div className={`p-3 rounded-xl ${getIconColor(notification.notification_type)}`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <div className="flex-1">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-medium text-gray-800">{notification.title}</h3>
                        <p className="text-gray-600 mt-1">{notification.message}</p>
                      </div>
                      <span className="text-sm text-gray-400">{formatRelativeTime(notification.created_at)}</span>
                    </div>
                    {notification.task && (
                      <Link to={`/tasks/${notification.task}`} className="text-blue-600 text-sm hover:underline mt-2 inline-block">
                        Topshiriqni ko'rish →
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <EmptyState icon={BellIcon} title="Xabarnomalar yo'q" description="Yangi xabarnomalar bu yerda ko'rsatiladi" />
      )}
    </div>
  );
};

export default Notifications;
